module.exports = __webpack_public_path__ + "weather.11c656861d93c022565d.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/weather/webfont/weather.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/weather/webfont/weather.woff
// module chunks = styles